import { render, staticRenderFns } from "./liveShare_old.vue?vue&type=template&id=3687e61f&scoped=true&"
import script from "./liveShare_old.vue?vue&type=script&lang=js&"
export * from "./liveShare_old.vue?vue&type=script&lang=js&"
import style0 from "./liveShare_old.vue?vue&type=style&index=0&id=3687e61f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687e61f",
  null
  
)

export default component.exports